import { Badge } from '@/components/ui/Badge';

/**
 * staff_attendance.type is stored verbatim from the legacy source (0/1, plus
 * an undocumented '2' seen on a handful of admin/teacher rows — see backend
 * docs/DEVIATIONS.md). Decoded for display only; `typeLabel` from the API
 * already carries the same decoding, this just adds color.
 */
export function StaffTypeBadge({ type, label }: { type: number; label: string }) {
  if (type === 1) return <Badge tone="green">{label}</Badge>;
  if (type === 0) return <Badge tone="red">{label}</Badge>;
  return <Badge tone="slate">{label}</Badge>;
}
